import React, { useState, useEffect } from 'react';
import './LendiCalculator.css';

const LENDI_PROXY_URL = process.env.REACT_APP_LENDI_PROXY_URL || 'https://lendi-proxy.twopoint.pl';

export function LendiCalculator({
  propertyPrice,
  collateral = 'Apartment',
  market = 'PrimaryMarket',
  downPaymentPercent = 20,
  periodYears = 30,
}: {
  propertyPrice: number;
  collateral?: 'Apartment' | 'House';
  market?: 'PrimaryMarket' | 'SecondaryMarket';
  downPaymentPercent?: number;
  periodYears?: number;
}) {
  const [installment, setInstallment] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const loanAmount = Math.round(propertyPrice * (1 - downPaymentPercent / 100));

  useEffect(() => {
    if (!propertyPrice || loanAmount <= 0) return;

    setLoading(true);
    setError(false);

    const params = new URLSearchParams({
      loanAmount: String(loanAmount),
      periodYears: String(periodYears),
      collateral,
      hypothecValue: String(propertyPrice),
      market,
    });
    const url = `${LENDI_PROXY_URL}?${params}`;

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((offers: Array<{ installment: number }>) => {
        const min = Math.min(...offers.map(o => o.installment));
        setInstallment(min);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [propertyPrice, collateral, market, downPaymentPercent, periodYears, loanAmount]);

  if (!propertyPrice || loanAmount <= 0) return null;

  return (
    <div className="lendi-teaser-info">
      <span className="lendi-teaser-label">Rata kredytu</span>
      {loading && <span className="lendi-teaser-loading">Obliczam...</span>}
      {error && <span className="lendi-teaser-error">Niedostępne</span>}
      {!loading && !error && installment != null && (
        <span className="lendi-teaser-value">
          {installment.toLocaleString('pl-PL')} zł / mies.
        </span>
      )}
    </div>
  );
}
